/* tslint:disable:no-any */
import { InjectionToken } from '../../injection';

/**
 * A minimal interface for dealing with zone.js zones. This is used in order to avoid adding a
 * direct dependency on the Angular zone.
 *
 * NOTE: This is an optional dependency that can be used by any application that uses zone.js for
 *       change detection, not just for angular application.
 *
 * Usage:
 *     @Inject(MOBIZ_ZONE) @Optional() mobizZone: IMobizZone | null,
 *
 * @see https://www.npmjs.com/package/zone.js
 * @see https://angular.io/guide/zone
 */
export interface IMobizZone {
  runOutsideZone<T>(fn: (...args: any[]) => T): T;
  runInsideZone<T>(fn: (...args: any[]) => T): T;
}

/**
 * A DI token that provides IMobizZone, which is required for dealing with zone.js zones.
 *
 * Usage in Angular:
 *     {
 *       provide: MOBIZ_ZONE,
 *       useFactory: (ngZone: NgZone) => {
 *         return {
 *           runOutsideZone: ngZone.runOutsideAngular.bind(ngZone),
 *           runInsideZone: ngZone.run.bind(ngZone),
 *         };
 *       deps: [NgZone],
 *     },
 */
export const MOBIZ_ZONE: InjectionToken<IMobizZone>
  = new InjectionToken<IMobizZone>('MOBIZ_ZONE');
